'use client'

import { Button, ButtonProps } from '../ui/button'
import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from '../ui/dialog'
import React, { Dispatch, FC, SetStateAction, useRef } from 'react'

type ModalProps = {
  open?: boolean
  setOpen?: Dispatch<SetStateAction<boolean>>
  children?: React.ReactNode
  buttonProps?: ButtonProps
  label?: string
}

const Modal: FC<ModalProps> = ({ children, open, setOpen, buttonProps, label = 'Open Modal' }) => {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button {...buttonProps}>
          <span>{label}</span>
        </Button>
      </DialogTrigger>
      <DialogContent>{children}</DialogContent>
    </Dialog>
  )
}

export default Modal
